import { render, staticRenderFns } from "./StickerDetail.vue?vue&type=template&id=7c9ecc90&scoped=true"
import script from "./StickerDetail.vue?vue&type=script&lang=js"
export * from "./StickerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9ecc90",
  null
  
)

export default component.exports